import {
    ACCOUNTS_FETCH,
    ACCOUNTS_FETCH_ALL,
    ACCOUNTS_IS_FETCING,
    ACCOUNTS_API,
    ACCOUNT_EDIT,
    ACCOUNT_FILTER,
    SET_ACCOUNT_PROFILE,
    SET_ACCOUNT_IB,
    SET_ACCOUNT_CLIENT
} from 'constants/accounts'

//HTTP reuests actions
import {
    put,
    post,
    remove,
    get
} from 'actions/requests'

//Save Accounts
export const accountSave = (data) => (dispatch, state) => {
    let action;
    if (data.accountId)
        action = put;
    else
        action = post;
    dispatch(accountsIsFetching(true))
    return action(`${ACCOUNTS_API}/${data.accountId || ''}`, data)
        .then((e) => { dispatch(accountsIsFetching(false)); return e; })
        .catch((e) => { dispatch(accountsIsFetching(false)); throw new Error(e) })
}

//Ressign Accounts
export const accountSaveReassign = (data) => (dispatch, state) => {
    let action;
    if (data.accountId)
        action = put;
    else
        action = post;
    dispatch(accountsIsFetching(true))
    return action(`${ACCOUNTS_API}/${data.accountId || ''}/reassign/?newClientId=${data.newClientId}`, data)
        .then((e) => { dispatch(accountsIsFetching(false)); return e; })
        .catch((e) => { dispatch(accountsIsFetching(false)); throw new Error(e) })
}



//Feth account by id
export const accountFetch = (id) => (dispatch) => {
        dispatch(accountsIsFetching(true));
        return get(`${ACCOUNTS_API}/${id}`)
            .finally(e => dispatch(accountsIsFetching(false)))
}

//Feth all accounts
export const accountsFetch = (clientId, ibId, query, loading=true) => (dispatch, state) => {
    dispatch(accountsIsFetching(loading));
    const filter = state().accounts.pageable
        const sorted = Object.keys(filter.sort).find(e => filter.sort[e])
        let params = {
            size: filter.size,
            page: filter.page,
            sort: sorted + ',' + filter.sort[sorted]
        }
        if (clientId) {
            params.clientId = clientId
        }
        if (ibId) {
            params.ibId = ibId
        }
        if (query) {
            params.filter = query
        }

    return get(`${ACCOUNTS_API}`, params)
        .then((e) => {
            dispatch(accountsFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
                accountFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(accountsIsFetching(false)))

}

//Feth all accounts
export const accountsFetchAll = (clientId, ibId, query, loading=true) => (dispatch, state) => {
    dispatch(accountsIsFetching(loading));
    	let params = {
			size: 1000000,
		}
		if (clientId) {
            params.clientId = clientId
        }
        if (ibId) {
			params.ibId = ibId
        }
        if (query) {
			params.filter = query
		}

    return get(`${ACCOUNTS_API}`, params)
        .then((e) => {
            dispatch(accountsFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
                accountFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(accountsIsFetching(false)))

}


//Remove one account
export const accountRemove = (id) => (dispatch, state) => {
    dispatch(accountsIsFetching(true))
    return remove(`${ACCOUNTS_API}/${id}`)
        .finally(e => dispatch(accountsIsFetching(false)))
}
export const accountsFetched = (payload) => ({ type: ACCOUNTS_FETCH, payload: payload })
export const accountsFetchedAll = (payload) => ({ type: ACCOUNTS_FETCH_ALL, payload: payload })
export const accountsIsFetching = (payload) => ({ type: ACCOUNTS_IS_FETCING, payload: payload })
export const accountEdit = (id, data) => ({ type: ACCOUNT_EDIT, payload: data })
export const accountFilter = (data) => ({ type: ACCOUNT_FILTER, payload: data })
export const setAccountProfile = (data) => ({ type: SET_ACCOUNT_PROFILE, payload: data })
export const setAccountIb = (data) => ({ type: SET_ACCOUNT_IB, payload: data })
export const setAccountClient = (data) => ({ type: SET_ACCOUNT_CLIENT, payload: data })


// WEBPACK FOOTER //
// ./src/actions/accounts.js